import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useLogger } from '../useLogger';

import {
  resolveIssue as resolveIssueEndpoint,
  unresolveIssue as unresolveIssueEndpoint,
} from '@/services/api/issues';

export const useResolveIssue = (propertyId: string) => {
  const queryClient = useQueryClient();
  const logger = useLogger('useResolveIssue');

  const { mutateAsync: resolveIssue, isPending: isResolvingIssue } = useMutation({
    mutationFn: (issueId: string) => resolveIssueEndpoint(issueId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['issues-for-property', propertyId] });
    },
    onError: (error) => {
      logger.error('Error resolving issue:', error);
    },
  });

  const { mutateAsync: unresolveIssue, isPending: isUnresolvingIssue } = useMutation({
    mutationFn: (issueId: string) => unresolveIssueEndpoint(issueId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['issues-for-property', propertyId] });
    },
    onError: (error) => {
      logger.error('Error unresolving issue:', error);
    },
  });

  return {
    resolveIssue,
    isResolvingIssue,

    unresolveIssue,
    isUnresolvingIssue,
  };
};
